/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import {
  Typography, Grid, Box,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import './GiftsMenu.css';
import Swal from 'sweetalert2';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { getGiftList as getGiftListData } from '@features/StreamGifts/services/streamGiftsApi';
import NumberWithCommas from '@shared/utils/NumberWithCommas';
import LoadingIndicator from '@shared/components/LoadingIndicator/LoadingIndicator';
import giftTabAllActive from '@assets/images/gifts/gift-tab1-active.png';
import campaignTabActive from '@assets/images/gifts/gift-tab2-active.png';
import voteTabActive from '@assets/images/gifts/gift-tab3-active.png';

import coin from '@assets/images/coin-logo.png';

const StyledTabs = withStyles({
  indicator: {
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#635ee7',

    },

  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(12),
    marginRight: theme.spacing(1),
    opacity: 0.3,
    '&:focus': {
      opacity: 1,
    },
    minWidth: '31%',
    padding: '5px',
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
}));

function GiftsMenu({ ...props }) {
  // import the custom styles from useStyles
  const classes = useStyles();
  const liveData = props.data;

  const MyStream = [];
  MyStream.asap = null;
  MyStream.contestStream = 13;
  MyStream.campaignId = 0;
  MyStream.giftList = [];

  const { contestStream } = MyStream;

  const { asap } = liveData;
  MyStream.asap = asap;
  const campaignId = liveData.campaign_id;

  if (Number(asap) === contestStream) {
    MyStream.campaignId = campaignId;
    MyStream.giftList = liveData.gift_list;
  }

  // open vg selection
  const [giftList, setGiftList] = useState();
  const [showCampaignVoteTab, setShowCampaignVoteTab] = useState(true);
  const [campaignGiftList, setCampaignGiftList] = useState([]);
  const [voteGiftList, setVoteGiftList] = useState([]);
  const [asapStream, setAsapStream] = useState(false);
  const [asapId, setAsapId] = useState();
  const [giftLoading, setGiftLoading] = useState(false);

  function getCampaignGifts(data) {
    const filteredGifts = [];
    data.forEach((gift) => {
      if (MyStream.giftList.includes(gift.guid)) {
        filteredGifts.push(gift);
      }
    });
    return filteredGifts;
  }

  function giftChunker(data) {
    if (data) {
      // filter hidden vgs
      const showedVgs = [];

      data.forEach((gift) => {
        if (gift.hide !== 1) {
          showedVgs.push(gift);
        }
      });

      const perChunk = 8; // items per chunk

      const inputArray = showedVgs;

      return inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
    }
  }

  const campaignGiftApi = () => {
    const giftListCampaignParams = new URLSearchParams({
      category: 2,
    }); // gift list - campaign

    getGiftListData(giftListCampaignParams)
      .then(((response) => {
        if (response.data.status === 'success') {
          if (response.data.code === '200') {
            const campaignData = response.data.data;
            const chunkedGifts = giftChunker(campaignData);
            setCampaignGiftList(chunkedGifts);
          } else if (response.data.code === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Something went wrong. Please try again.',
            });
          }
        }
      }))
      .catch((error) => {
        console.error(error);
      });
  };

  const voteGiftApi = () => {
    // VOTE GIFTS
    const giftListVoteParams = new URLSearchParams({
      category: 'vote',
    }); // gift list - vote

    getGiftListData(giftListVoteParams)
      .then(((response) => {
        if (response.data.status === 'success') {
          if (response.data.code === '200') {
            const voteData = response.data.data;
            const chunkedVoteGifts = giftChunker(voteData);
            setVoteGiftList(chunkedVoteGifts);
          } else if (response.data.code === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Something went wrong. Please try again.',
            });
          }
        }
      }))
      .catch((error) => {
        console.error(error);
      });
  };

  const getGiftList = () => {
    setGiftLoading(true);
    // call vg list here
    let giftListAllParams = new URLSearchParams({
      category: 1,
    }); // gift list - all
    if (MyStream.asap > 10 && MyStream.asap < 20) {
      giftListAllParams = new URLSearchParams({
        category: MyStream.asap,
      });
      setAsapId(MyStream.asap);
      setShowCampaignVoteTab(false);
    }

    getGiftListData(giftListAllParams)
      .then(((response) => {
        if (response.data.status === 'success') {
          if (response.data.code === '200') {
            const giftData = response.data.data;
            setGiftLoading(false);
            if (MyStream.giftList && MyStream.campaignId) { // campaign gifts
              const campaignGifts = getCampaignGifts(giftData);
              const chunkedCampaignGifts = giftChunker(campaignGifts);
              setGiftList(chunkedCampaignGifts);
              setAsapStream(true);
            } else {
              const chunkedGifts = giftChunker(giftData);
              setGiftList(chunkedGifts);
            }
          } else if (response.data.code === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Something went wrong. Please try again.',
            });
          }
        }
      }))
      .catch((error) => {
        console.error(error);
      });

    if (showCampaignVoteTab) { // load campaign gifts
      campaignGiftApi();
      voteGiftApi();
    }
  };

  useEffect(() => {
    getGiftList();
  }, []);

  const [value, setValue] = useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(data) {
    const { children, index, ...other } = data;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        className='gift-tab-panel'
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function handleChangeTab(index) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  function renderCampaignVoteTab() {
    if (showCampaignVoteTab) {
      const tabItem = [
        {
          index: 1,
          label: 'CAMPAIGN',
          icon: <img width='40px' src={campaignTabActive} alt='campaign icon' />,
        },
        {
          index: 2,
          label: 'VOTING',
          icon: <img width='20px' src={voteTabActive} alt='voting icon' />,
        },
      ];
      return (
        tabItem.map((item) => (
          <StyledTab
            label={item.label}
            icon={item.icon}
            onClick={() => (handleChangeTab(item.index))}
          />
        ))
      );
    }
  }

  const renderGiftElement = (gift) => (
    <>
      <img className='img-fluid' src={gift.image} alt='gift' />
      <Typography className='giftName'>{gift.name}</Typography>
      <div className='giftCoins'>
        <img src={coin} height='15' width='15' alt='coin' />
        {NumberWithCommas(gift.coin)}
      </div>
    </>

  );

  let selectedVg = '';
  const selectVgHighlight = (guid, category) => {
    if (selectedVg !== '') {
      const selectedElement = document.getElementById(selectedVg);
      if (selectedElement) {
        // remove class of previously selected vg
        document.getElementById(selectedVg).className = '';
        document.getElementById(selectedVg).className = 'giftBox';
      }
    }
    selectedVg = guid;
    // update class of selected vg
    document.getElementById(guid).className = 'giftBox giftBox-selected';
    props.selectVg(guid, category);
  };

  function renderCampaignTab() {
    if (showCampaignVoteTab && campaignGiftList) {
      return (
        <Carousel
          navButtonsAlwaysVisible
          autoPlay={false}
          animation='slide'
          swipe
          fullHeightHover={false}
          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
          navButtonsProps={{
            style: {
              margin: '0 -20px',
              backgroundColor: 'transparent',

            },
          }}
          indicatorIconButtonProps={{
            style: {
              padding: '1px',
              color: 'gray',
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              color: 'gray',
              backgroundColor: '#6e48bf',
            },
          }}
          indicatorContainerProps={{
            style: {
              textAlign: 'center', // 4
              height: '50px',
            },

          }}
        >
          {campaignGiftList.map((campaignGiftArray) => (
            <Grid container style={{ height: '180px' }}>
              {campaignGiftArray.map((gift) => (
                <Grid style={{ marginBottom: '20px' }} item xs={3} sm={3} md={3} lg={3}>
                  <div className='col-3 giftBoxPanel '>
                    <div id={gift.guid} className='giftBox' data-guid={gift.guid} data-cat='2' onClick={() => { selectVgHighlight(gift.guid, 2); }}>
                      {renderGiftElement(gift)}
                    </div>
                  </div>
                </Grid>

              ))}
            </Grid>
          ))}

        </Carousel>
      );
    }
  }

  function renderVoteTab() {
    if (showCampaignVoteTab && voteGiftList) {
      return (
        <Carousel
          navButtonsAlwaysVisible
          autoPlay={false}
          animation='slide'
          swipe
          fullHeightHover={false}
          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
          navButtonsProps={{
            style: {
              margin: '0 -20px',
              backgroundColor: 'transparent',

            },
          }}
          indicatorIconButtonProps={{
            style: {
              padding: '1px',
              color: 'gray',
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              color: 'gray',
              backgroundColor: '#6e48bf',
            },
          }}
          indicatorContainerProps={{
            style: {
              textAlign: 'center', // 4
            },

          }}
        >
          {voteGiftList.map((voteGiftArray) => (
            <Grid container style={{ height: '180px' }}>
              {voteGiftArray.map((gift) => (
                <Grid style={{ marginBottom: '20px' }} item xs={3} sm={3} md={3} lg={3}>
                  <div className='col-3 giftBoxPanel '>
                    <div id={gift.guid} className='giftBox' data-guid={gift.guid} data-cat='3' onClick={() => { selectVgHighlight(gift.guid, 3); }}>
                      {renderGiftElement(gift)}
                    </div>
                  </div>
                </Grid>

              ))}
            </Grid>
          ))}

        </Carousel>
      );
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <div>
        <div className={classes.root}>
          <StyledTabs value={value} onChange={handleChange} aria-label='styled tabs' className='style-giftcont'>
            <StyledTab
              label='ALL'
              onClick={() => { handleChangeTab(0); }}
              icon={<img src={giftTabAllActive} width='20px' alt='active tab icon' />}
            />
            {renderCampaignVoteTab()}

          </StyledTabs>
          {giftLoading
            ? (
              <div style={{ marginBottom: 10 }}>
                <LoadingIndicator />
              </div>
            )
            : (
              <>
                <TabPanel value={value} index={0} style={{ padding: '10px' }}>
                  <>
                    {giftList
                        && (
                          <Carousel
                            navButtonsAlwaysVisible
                            autoPlay={false}
                            animation='slide'
                            swipe
                            fullHeightHover={false}
                            indicatorIconButtonProps={{
                              style: {
                                padding: '1px',
                                color: 'gray',
                              },
                            }}
                            activeIndicatorIconButtonProps={{
                              style: {
                                color: 'gray',
                                backgroundColor: '#6e48bf',
                              },
                            }}
                            indicatorContainerProps={{
                              style: {
                                textAlign: 'center', // 4
                              },

                            }}
                            // Change the colors and radius of the actual buttons.
                            // THIS STYLES BOTH BUTTONS
                            navButtonsProps={{
                              style: {
                                margin: '0 -20px',
                                backgroundColor: 'transparent',

                              },
                            }}
                          >
                            {giftList.map((giftArray) => (
                              <Grid container style={{ height: '180px' }}>
                                {giftArray.map((gift) => (
                                  <Grid style={{ marginBottom: '20px' }} item xs={3} sm={3} md={3} lg={3}>
                                    <div className='col-3 giftBoxPanel '>
                                      <div
                                        id={gift.guid}
                                        className='giftBox'
                                        data-guid={gift.guid}
                                        data-cat={asapStream ? asapId : '1'}
                                        onClick={() => {
                                          selectVgHighlight(
                                            gift.guid,
                                            asapStream ? asapId : 1,
                                          );
                                        }}
                                      >
                                        {renderGiftElement(gift)}
                                      </div>
                                    </div>
                                  </Grid>
                                ))}
                              </Grid>
                            ))}

                          </Carousel>
                        )}
                  </>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  {renderCampaignTab()}
                </TabPanel>
                <TabPanel value={value} index={2}>
                  {renderVoteTab()}
                </TabPanel>
              </>
            )}

        </div>
      </div>
    </div>
  );
}

export default GiftsMenu;
